import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import React from "react"
import { PortfolioSnapshotType } from "../models/board"
import styles from "./PortfolioBar.module.scss"

const PROJECTS_COLOR = "#36acd7"

/** Полупрозрачный оттенок цвета доски: заливка и обводка выбранной вкладки */
const tint = (color: string, alpha: number) => {
  const hex = color.replace("#", "")
  const value = parseInt(hex.length === 3 ? hex.replace(/(.)/g, "$1$1") : hex, 16)

  return `rgba(${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}, ${alpha})`
}

/**
 * Доски заданий в шапке страницы: вкладки-«пилюли» с цветной точкой.
 * Первая вкладка — общие задания по проектам, остальные заводят сотрудники
 */
export const PortfolioBar: React.FC<PortfolioBarProps> = ({
  portfolios,
  currentId,
  canCreate,
  onSelect,
  onCreate,
  onEdit,
}) => (
  <div className={styles.bar}>
    <BoardTab
      color={PROJECTS_COLOR}
      name="Задания по проектам"
      active={!currentId}
      onSelect={() => onSelect("")}
    />

    {portfolios.map((portfolio) => (
      <BoardTab
        key={portfolio.id}
        color={portfolio.color}
        name={portfolio.name}
        active={currentId === portfolio.id}
        onSelect={() => onSelect(portfolio.id)}
        onEdit={portfolio.canManage ? () => onEdit(portfolio) : undefined}
      />
    ))}

    {/* приглашённые видят чужие доски и без права заводить свои */}
    {canCreate && (
      <button type="button" className={styles.add} onClick={onCreate} title="Создать доску заданий">
        <GeneralIcon type="general-plus-small" size={12} />
        Добавить доску
      </button>
    )}
  </div>
)

const BoardTab: React.FC<BoardTabProps> = ({ color, name, active, onSelect, onEdit }) => (
  <button
    type="button"
    className={`${styles.tab} ${active ? styles.active : ""}`}
    style={
      active
        ? { backgroundColor: tint(color, 0.14), borderColor: color, color }
        : { borderColor: tint(color, 0.35) }
    }
    onClick={onSelect}
  >
    <span
      className={styles.dot}
      style={{
        backgroundColor: active ? color : tint(color, 0.35),
        boxShadow: active ? `0 0 0 3px ${tint(color, 0.25)}` : undefined,
      }}
    />

    <span className={styles.name} title={name}>
      {name}
    </span>

    {onEdit && (
      <span
        className={styles.edit}
        title="Настроить доску"
        onClick={(e) => {
          e.stopPropagation()
          onEdit()
        }}
      >
        <GeneralIcon type="general-edit" size={11} />
      </span>
    )}
  </button>
)

interface BoardTabProps {
  color: string
  name: string
  active: boolean
  onSelect: () => void
  onEdit?: () => void
}

interface PortfolioBarProps {
  portfolios: PortfolioSnapshotType[]
  currentId: string
  /** Может ли текущий пользователь завести свою доску */
  canCreate: boolean
  onSelect: (id: string) => void
  onCreate: () => void
  onEdit: (portfolio: PortfolioSnapshotType) => void
}
